import "./Home.scss";

import * as basicScroll from 'basicscroll'
import {useEffect, useState} from 'react'
// import {useDispatch, useSelector} from "react-redux";
import axios from "axios"
import clevertap from "clevertap-web-sdk";
// import {CMC} from "./cmc"
import {motion} from "framer-motion"
// import Faq from "./Faq"
import Main from "./Main"
import Market from "../Markets/Details/Currencies"
import Card from "./card"
// import Fomode from "./fomode"
import {Widget} from '@typeform/embed-react'
// import Lottie from "lottie-react";
// import trophy from "./Assets/trophy.json";
// import leverage from "./Assets/leverage.json";
// import proLight from "./Assets/pro-light.json";
// import {getContentList} from "../../store/actions/Content/GetContentList";
// import list from "../WalletOverview/AssetBalances/List";
import {useTranslation} from "react-i18next";
import session_manager from "../../utils/SessionManager";
import LazyLoad from "react-lazyload";

export default function Home() {
  /**
   * @type {Dispatch<AnyAction>}
   */
  // const dispatch = useDispatch();

  /**
   * Init translation
   */
  const { t, i18n } = useTranslation();

  /**
   * Get store data
   */
  // const contentList = useSelector(state => state.content.list);

  /**
   * Set local data
   */
  const [data, setData] = useState({list: []});
  const baseUrl = "https://s3.coinmarketcap.com/generated/sparklines/web/7d/usd"

  const loadData = async () => {
    const config = await axios.get(`${process.env.REACT_APP_API_URL}/api/default/config?p=5`)
    const data = await axios.get(`${process.env.REACT_APP_API_URL}/api/default/ticker?p=5`)

    setData({config: config.data.data, list: data.data.data})

    //  await new Promise(resolve => setTimeout(resolve, 2000));
    //  $(".home-logo").attr("src","./images/home/home.svg");
    //  $(".home-logo").animate({"opacity":"0"},"fast");
    //  $(".home-logo").toggleClass('animate');

    //  $(".gradient").toggleClass('animate');
    //  $(".v-preloader__loading").toggleClass('animate');
  }

  useEffect(() => {
    loadData();

    clevertap.event.push("home_page_loaded", {
      isLoggedIn: session_manager.isLoggedIn()
    });

    var parallax_sections = document.querySelectorAll('.sectionhero');

    for (let parallax_section of parallax_sections) {
      let _from = parallax_section.getAttribute("data-from") || '50%';
      let _to = parallax_section.getAttribute("data-to") || '150%';
      let instance = basicScroll.create({
        elem: parallax_section,
        from: 'top-middle',
        to: 'bottom-middle',
        direct: true,
        track: false,
        props: {
          '--scale': {
            from: _from,
            to: _to,
          }
        }
      })

      instance.start();
    }

    parallax_sections = document.querySelectorAll('.page-anim');
    for (let parallax_section of parallax_sections) {
      let instance = basicScroll.create({
        elem: parallax_section,
        from: 'top-middle',
        to: 'bottom-middle',
        direct: true,
        track: false,
        props: {
          '--width': {
            from: "100%",
            to: "200%",
          },
          '--left': {
            from: "-0",
            to: "-50%",
          },
          '--height': {
            from: "100%",
            to: "1500%",
          }
        }
      })

      instance.start();
    }
  }, []);

  /**
   * Watch localization, load content
   */
  // useEffect(() => {
  //   dispatch(getContentList('blog', i18n.language));
  // },[i18n.language])

  /**
   * Render HTML
   */
  return (
    <>
      <div style={{backgroundColor: "#141414"}}  className="home-styles-container  overflow-hidden">
     
        <div style={{backgroundColor: "#141414"}}>
          
          {/* <Header /> */}
          <Main />
        </div>

        <div style={{backgroundColor: "#141414"}}>
          <div className="section hero-image-section">
            <div
              data-w-id="04ca7d1a-577b-75a0-daf9-ebe387511ed9"
              style={{
                WebkitTransform:
                  "translate3d(0, 20vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                MozTransform:
                  "translate3d(0, 20vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                msTransform:
                  "translate3d(0, 20vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                transform:
                  "translate3d(0, 20vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
              }}
              className="hero-section-container"
            >
              <div className="hero-sticky-content">
                <div className="hero-product-holder">
                  <div className="hero-product-gradient-container">
                    <div className="product-holder">
                      {/* <div
                          src="/markets"
                          loading="lazy"
                          height={600}
                          alt="Screenshot of the Unvest app showing the vesting progress of a project with a claim button and interactive chart."
                          data-w-id="baaa8529-c728-2af1-6843-0b1437aa1b01"
                          className="product overflow-hidden"

                      >
                          <div className="top flex flex-wrap justify-center pt-16 p-2 gap-3">

{data.list.map((element, key) => {
if(key <9)
    return (
        <div className="ticker" key={`key1` + key}>
          <img loading="lazy"
               src={`${data.config.currency_icons[element.main.iso3]}`}
               alt="Currency" width="40"/>
          <div className="name">
            <span>{element.main.name}</span><span>{element.main.iso3}</span>
          </div>
          <img loading="lazy"
               className={`chart ${element.percent > 0 ? "pos" : "neg"}`}
               src={`${baseUrl + '/' + CMC[element.main.iso3] + '.svg'}`}
               width="80px" alt="usd/BTC"/>
          <div className="price-ticker">
            <p>${parseFloat(element.main.rate_usdt / (10 ** element.main.decimal)).toFixed(2)}</p>
          </div>
          <div className="tag">{parseFloat(element.percent).toFixed(2)}%</div>
        </div>
    )
})}
</div>
                      </div> */}

                      <div
                        src="/markets"
                        loading="lazy"
                        alt={t(`home.markets`)}
                        data-w-id="baaa8529-c728-2af1-6843-0b1437aa1b01"
                        className="product overflow-hidden md:pt-16 p-3"
                        style={{height: 800}}
                      >
                        <Market onlyFavs={false}/>
                      </div>
                      <a href="#" className="product-lightbox w-inline-block w-lightbox">
                        <div className="lightbox-icon-holder"></div>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="grid-hero-images-container">
                  <div className="grid-hero-images _1">
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 90px, (max-width: 1439px) 180px, (max-width: 1919px) 270px, 360px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _2"
                    />
                    <img
                        src="/images/home/desktop-3.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-3.png"
                        className="hero-image _3"
                    />
                    <img
                        src="/images/home/desktop-3.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-3.png"
                        className="hero-image _4"
                    />
                    <img
                        src="/images/home/desktop-3.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-3.png"
                        className="hero-image _5"
                    />
                    <img
                        src="/images/home/desktop-3.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-3.png"
                        className="hero-image _6"
                    />
                    <img
                        src="/images/home/desktop-3.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-3.png"
                        className="hero-image _7"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _8"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _9"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _10"
                    />
                  </div>
                  <div className="grid-hero-images _2">
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 90px, (max-width: 1439px) 180px, (max-width: 1919px) 270px, 360px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _2"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _3"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _4"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _5"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _6"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _7"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 25vw, (max-width: 991px) 140px, 160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _8"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _9"
                    />
                    <img
                        src="/images/home/desktop-2.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        sizes="160px"
                        srcSet="/images/home/desktop-2.png"
                        className="hero-image _10"
                    />
                  </div>
                  <div className="grid-images-overlay"/>
                  <div className="grid-images-overlay right"/>
                </div> */}
              </div>
            </div>
          </div>
          <div className="section top-margin">
            <div className="container trusted-companies-container w-container">
              <div className="center-text">
                <div className="trusted-companies-header">{t(`home.partners`)}</div>
              </div>
              <div className="w-layout-grid trusted-companies-grid">
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                      <img
                          src="/images/home/fireblocks.svg"
                          loading="lazy"
                          alt="Fireblocks EXZi"
                          className="trusted-companies-image wyv"
                      />
                    </LazyLoad>                 
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                      <img
                          src="/images/home/aquanow.svg"
                          loading="lazy"
                          alt="aquanow EXZi logo"
                          className="trusted-companies-image x21"
                      />
                    </LazyLoad>
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                      <img
                          src="/images/home/ondato.svg"
                          loading="lazy"
                          alt="ondato logo"
                          className="trusted-companies-image ondato"
                      />
                    </LazyLoad>
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                      <img
                          src="/images/home/tradingview.svg"
                          loading="lazy"
                          alt="tradingview logo"
                          className="trusted-companies-image tv"
                      />
                    </LazyLoad>
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                      <img
                          src="/images/home/scorechain.svg"
                          loading="lazy"
                          alt="scorechain logo"
                          className="trusted-companies-image multi"
                      />
                    </LazyLoad>
                    
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                    <img
                        src="/images/home/hawk.svg"
                        loading="lazy"
                        alt="Chainlink logo"
                        className="trusted-companies-image hawk"
                    />
                    </LazyLoad>
                    
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                    <img
                        src="/images/home/onesignal.svg"
                        loading="lazy"
                        alt="Chainlink logo"
                        className="trusted-companies-image onesignal"
                    />
                    </LazyLoad>
                    
                  </div>
                </div>
                <div className="block-logo-holder">
                  <div className="fade-in-on-scroll">
                    <LazyLoad offset={200}>
                    <img
                        src="/images/home/twilio.svg"
                        loading="lazy"
                        alt="Chainlink logo"
                        className="trusted-companies-image twilio"
                    />
                    </LazyLoad>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="sectiongeneral">
            <div className="generalcontainer w-container">
              <div className="sectiontitle">
                <div className="sectiontitle page-anim"></div>
                <h2 className="sectionh1">
                  <span className="text-span">{t('home.tradeLike.0')}</span> {i18n.language === 'tr' &&
                    <br/>} {t('home.tradeLike.1')}<br/>{t('home.tradeLike.2')}
                </h2>
              </div>
              <div
                data-poster-url="/"
                data-video-urls="/images/home/phone-animation-web.mp4"
                data-autoplay="true"
                data-loop="true"
                data-wf-ignore="true"
                className="sectionvideocontent w-background-video w-background-video-atom"
              >
                <video
                  id="e8b19663-3a63-766f-c2ad-c29b0564f9d4-video"
                  autoPlay
                  loop
                  style={{
                    backgroundImage: 'url("/")'
                  }}
                  muted
                  playsInline
                >
                  <source src="/images/home/phone-animation-web.mp4" data-wf-ignore="true"/>
                  <source src="/images/home/phone-animation-web.mp4" data-wf-ignore="true"/>
                </video>
                <div className="contentwrapper">
                  <div className="iconsection">
                    <LazyLoad offset={200}>
                    <img
                        src="/images/home/exzi-skeleton.svg"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        style={{padding: "1em"}}
                        className="image-14"
                    />
                    </LazyLoad>
                    
                  </div>
                  <h2 className="sectionh2 inside">
                    {t('home.trading.0')} <span className="headinghero sectionh2">{t('home.trading.1')}</span> {t('home.trading.2')}
                  </h2>
                  <p className="sectionp dark">{t('home.trading.text1')}</p>
                  <p className="disclaimerglobalizin">{t('home.trading.text2')}</p>
                </div>
              </div>
              <div className="sectionvideomobile">
                <div className="contentwrapper">
                  <div className="iconsection">
                    <LazyLoad offset={200}>
                    <img
                      src="/images/home/exzi-skeleton.svg"
                      loading="lazy"
                      alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                      className="image-14"
                    />
                    </LazyLoad>
                    
                  </div>
                  <h2 className="sectionh2 inside white">{t('home.trading.title')}</h2>
                  <p className="sectionp dark">{t('home.trading.text1')}</p>
                  <p className="disclaimerglobalizin">{t('home.trading.text2')}</p>
                </div>
                <div
                  data-poster-url="https://global-uploads.webflow.com/62fbf47aa77175d7f3cbee73/630fc1e845f555d975b7e998_exziAppM-poster-00001.jpg"
                  data-video-urls="/images/home/video-mobile.mp4"
                  data-autoplay="true"
                  data-loop="true"
                  data-wf-ignore="true"
                  className="background-video w-background-video w-background-video-atom"
                >
                  <video
                    id="df737776-bf4a-3cdd-bdae-0b61899c9734-video"
                    autoPlay
                    loop
                    style={{
                      backgroundImage:
                        'url("https://global-uploads.webflow.com/62fbf47aa77175d7f3cbee73/630fc1e845f555d975b7e998_exziAppM-poster-00001.jpg")'
                    }}
                    muted
                    playsInline
                  >
                    <source src="/images/home/video-mobile.mp4" data-wf-ignore="true"/>
                  </video>
                </div>
              </div>
              <div className="sectionmidcontent dark">
                <Card dark title={t('home.security.title')} text={t('home.security.text')}
                      color={"linear-gradient(135deg, #ffffff, #99c1d2)"}>
                        <LazyLoad offset={200}>
                        <motion.img
                    initial={{opacity: 0.4, x: 200}}
                    whileInView={{opacity: 1, x: 0}}
                    transition={{delay: 0.2, duration: 0.8}} src='/images/home/security.png'/>

                        </LazyLoad>
                 
                  <h2 className="sectionh3 pt-7 text-span-2">
                    <span className='text-span-3'>{t('home.security.h2.0')}</span>
                    <br/>{t('home.security.h2.1')}
                  </h2>
                </Card>
                <Card title={t('home.support.title')} text={t('home.support.text')}
                      color={"radial-gradient(at 5% 5%, rgb(0 0 0) 0%, rgba(0, 0, 0, 0) 75%), radial-gradient(at 95% 5%, rgb(0 0 0) 0%, rgb(74 74 74 / 0%) 75%), radial-gradient(at 95% 95%, rgb(60 150 175) 0%, rgb(64 167 196 / 0%) 75%), radial-gradient(at 5% 95%, rgb(0 0 0) 0%, rgba(95, 194, 138, 0) 75%)"}>
                  <h2 className="sectionh3 dark pb-3 pt-12">{t('home.support.h2.0')}<br/>{t('home.support.h2.1')}</h2>
                  <LazyLoad offset={200}>
                  <motion.img
                    initial={{opacity: 0.4, y: 100}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{delay: 0.2, duration: 0.8}} src='/images/home/support.png'/>
                  </LazyLoad>
                 
                </Card>
              </div>
              {/* <div className="sectionfullcontent white investors">
                <div className="contentwrapper">
                  <div className="iconsection dark">
                    <img
                        src="/images/home/bitcoin.svg"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        className="image-15"
                    />
                  </div>
                  <h2 className="sectionh2 inside">
                    All Coins
                    <br/> in one Place.
                  </h2>
                </div>
                <div className="lottie-animation-ticker-2">
                  {data.list.map((element, key) => {
                    if (key < 10) {
                      return (
                          <div className="ticker" key={`key1` + key}>
                            <img loading="lazy"
                                 src={`${data.config.currency_icons[element.main.iso3]}`}
                                 alt="Currency" width="40"/>
                            <div className="name">
                              <span>{element.main.name}</span><span>{element.main.iso3}</span>
                            </div>
                            <img loading="lazy"
                                 className={`chart ${element.percent > 0 ? "pos" : "neg"}`}
                                 src={`${baseUrl + '/' + CMC[element.main.iso3] + '.svg'}`}
                                 width="80px" alt="usd/BTC"/>
                            <div className="price-ticker">
                              <p>${parseFloat(element.main.rate_usdt / (10 ** element.main.decimal)).toFixed(2)}</p>
                            </div>
                            <div className="tag">{parseFloat(element.percent).toFixed(2)}%</div>
                          </div>
                      )
                    }
                  })}
                </div>
                <div className="lottie-animation-ticker-1">
                  {data.list.map((element, key) => {
                    if (key < 10) {
                      return (
                          <div className="ticker" key={`key2` + key}>
                            <img loading="lazy"
                                 src={`${data.config.currency_icons[element.main.iso3]}`}
                                 alt="Currency" width="40"/>
                            <div className="name">
                              <span>{element.main.name}</span><span>{element.main.iso3}</span>
                            </div>
                            <img loading="lazy"
                                 className={`chart ${element.percent > 0 ? "pos" : "neg"}`}
                                 src={`${baseUrl + '/' + CMC[element.main.iso3] + '.svg'}`}
                                 width="80px" alt="usd/BTC"/>
                            <div className="price-ticker">
                              <p>${parseFloat(element.main.rate_usdt / (10 ** element.main.decimal)).toFixed(2)}</p>
                            </div>
                            <div className="tag">{parseFloat(element.percent).toFixed(2)}%</div>
                          </div>
                      )
                    }
                  })}
                </div>
              </div> */}
            </div>
          </div>
          <div className="sectiongetpaid">
            <div className="generalcontainer w-container">
              <div className="sectiontitle getpaid">
                <div className="sectiontitle getpaid page-anim"/>
                <h2 className="sectionh1">
                  <span className="text-span-5">{t('home.oneapp.header0')}</span> {t('home.oneapp.header1')}
                </h2>
              </div>
              <div className="sectionfullcontent white general">
                <div className="contentwrapper">
                  <div className="iconsection dark">
                    <LazyLoad offset={200}>
                    <img
                        src="/images/logo.png"
                        loading="lazy"
                        alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                        className="image-17 "
                        width={40}
                    />
                    </LazyLoad>
                    
                  </div>
                  <h2 className="sectionh2 inside py-4">{t('home.oneapp.header2')}<br/> {t('home.oneapp.header3')}</h2>
                  {/*<p className="sectionp">*/}
                  {/*  Swift Onboarding For newcomers, the platform's straightforward*/}
                  {/*  navigation offers a clear pathway, guiding them through each step*/}
                  {/*  with intuitive prompts and concise tooltips.*/}
                  {/*  <br />*/}
                  {/*  <br />*/}
                  {/*  What truly sets EXZi apart is its pioneering integration of web3*/}
                  {/*  wallet verification for first-time users.*/}
                  {/*</p>*/}
                  <p style={{textAlign:"justify"}}>{t('home.oneapp.text1')}</p>
                  {/* <p className="disclaimerglobalizin dark">{t('home.oneapp.text2')}</p> */}
                </div>
              </div>
              <div className="sectionmidcontent dark short">
                <div className="leftcontent countries">
                  <div className="contentmidwrapper">
                    <h2 className="sectionh3 dark">
                      {t(`home.authorized.title0`)}
                      <span style={{color: "#FFCC00"}} className='flex items-center gap-3'>{t(`home.authorized.title1`)}
                      <LazyLoad offset={200}>
                      <img src='/images/home/eu.png' className='pb-2' width={50} alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi" />
                      </LazyLoad>
                        </span> {t(`home.authorized.title2`)}
                    </h2>
                    <p className="disclaimerglobalizin">{t(`home.authorized.text`)}</p>
                    <LazyLoad offset={200}>
                    <motion.img
                        initial={{opacity: 0, x: -40}}
                        transition={{delay: 0.4, duration: 3}}
                        exit={{opacity: 0}}
                        whileInView={{
                          rotate: [0, 100],
                          opacity: 1,
                          x: 0,
                        }}
                        width={"80%"}
                        src='/images/home/eu.png' className='absolute'
                        style={{top: "0%", right: "50%"}}
                    />
                    </LazyLoad>
                   
                    {/* <div className="lottie-animation-countries-1 lottie-animation-countries">
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/gr.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>GRE</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/mc.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>MON</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/ie.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>IRE</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/no.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>NOR</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/se.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>SWE</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/hr.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>CRO</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/lt.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>LIT</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/gb.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>GBT</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/pt.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>POR</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/lv.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>LAT</span>
                        </div>
                      </div>
                    </div>
                    <div className="lottie-animation-countries-2 lottie-animation-countries">
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/es.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>ESP</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/it.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>ITA</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/dk.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>DEN</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/at.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>ATL</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/gr.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>GRE</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/be.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>BEL</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/ua.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>UKR</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/ee.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>EST</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/fr.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>FRA</span>
                        </div>
                      </div>
                      <div className="ticker">
                        <img
                            loading="lazy"
                            src="/images/home/countries/nl.svg"
                            alt="Currency"
                            width={40}
                        />
                        <div className="name">
                          <span>NLD</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
                <Card
                  title={t(`home.secured.title`)}
                  text={t(`home.secured.text`)}
                  color={"#030614"}>
                  <div className="text-left p-10 pb-0">
                    <h2 className="sectionh3 dark">
                      {t(`home.secured.h2.0`)} <br/>
                      <span className='text-span-4'>{t(`home.secured.h2.1`)}</span><br/>{t(`home.secured.h2.2`)}
                      <br/>{t(`home.secured.h2.3`)}
                    </h2>
                    <p className='pt-5'>{t(`home.secured.powered`)}</p>
                    <div className='flex items-center gap-5'>
                      <LazyLoad offset={200}>
                      <img
                          src="/images/home/fireblocks.svg"
                          loading="lazy"
                          alt="fireblocks"
                          width={100}
                      />
                      </LazyLoad>
                      <LazyLoad offset={200}>
                      <img
                          src="/images/home/ondato.svg"
                          loading="lazy"
                          alt="ondato logo"
                          width={70}
                      />
                      </LazyLoad>
                      <LazyLoad offset={200}>
                      <img
                          src="/images/home/hawk.svg"
                          loading="lazy"
                          alt="hawk logo"
                          width={100}
                      />
                      </LazyLoad>
                      
                    </div>
                  </div>
                  <LazyLoad offset={200}>
                  <motion.img
                      initial={{opacity: 0, y: 200}}
                      whileInView={{opacity: 1, y: 0}}
                      transition={{delay: 0.2, duration: 0.7}}
                      exit={{opacity: 0}}
                      src='/images/home/code.png'/>
                  </LazyLoad>
                 
                </Card>
              </div>
            </div>
          </div>

          <div className="sectiongetpaid">
            <div className="generalcontainer w-container">
              {/* <div className="sectiontitle future">
                <div className="sectiontitle future  page-anim"/>
                <h2 className="sectionh1">
                  <span className="text-span-7">Upcoming</span> Greatness.
                </h2>
              </div> */}
              {/* <div className="sectionmidcontent dark short">
        <Fomode />
        <Card title={"Stories"} text={"In a bold move to intertwine the excitement of crypto trading with the essence of social sharing, EXZi will introduce a unique 'story' section within its platform.\n\n\
This feature allows traders to record and share their triumphant moments, victories, and strategic wins on a story timeline, much akin to popular social media platforms.\n\n\
Beyond merely showcasing profitability, these stories can capture the emotion, strategy, and journey behind each trade, providing a holistic view of a trader's experience. \nFor onlookers, these stories serve as both motivation and education, allowing them to witness real-time decision- making, celebrate the successes of fellow traders, and perhaps glean insights for their trades."}
comingSoon
color={"radial-gradient(#4d8ce3, #1b5db8)"}>
                <motion.img
                initial={{ opacity: 0, y: -200 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay:0.2, duration: 0.7 }}
                exit={{ opacity: 0 }} src='/images/home/stories.png' />
                <h2 className="sectionh3 dark ">Stories</h2>
              </Card>
        </div> */}
              {/*<div className="sectionmidcontent dark short">*/}
              {/*    <Card title={"Leaderboard"} text={"Dynamic leaderboard ranks traders based on various metrics such as trading volume, consistent profitability, or monthly gains, offering a transparent display of top- performing individuals on the platform.\n\n\*/}
              {/*        Beyond the thrill of competition, this leaderboard serves as a beacon of inspiration for many.\n\n\*/}
              {/*        Newcomers can glean insights from the trading styles of top-ranking individuals, potentially adapting strategies that align with their own goals.\n\n\*/}
              {/*        For seasoned traders, it presents an opportunity to be recognized for their prowess, and perhaps more significantly, it creates a sense of camaraderie and healthy competition within the EXZi community."}*/}
              {/*          comingSoon*/}
              {/*          color={"#000"}>*/}
              {/*        <div className="flex justify-center pt-5">*/}
              {/*            <Lottie*/}
              {/*                animationData={trophy}*/}
              {/*                style={{width: 80}}*/}
              {/*                loop={true}*/}
              {/*            />*/}
              {/*        </div>*/}
              {/*        /!*<h2 className="sectionh3 dark  md:pb-6">Leader<br/>Board</h2>*!/*/}
              {/*        <motion.img*/}
              {/*            initial={{opacity: 0, y: 100}}*/}
              {/*            whileInView={{opacity: 1, y: 0}}*/}
              {/*            transition={{delay: 0.2, duration: 0.7}}*/}
              {/*            src='/images/home/leaderboard.png'/>*/}
              {/*    </Card>*/}
              {/*    <Card title={"Copy Trading"} text={"EXZi's light mode simplifies the trading landscape, presenting only the essential features in a clean, clutter-free interface.\n\n\*/}
              {/*            This ensures that newcomers aren't bombarded with excessive information, allowing them to focus on understanding the fundamentals and gradually gaining confidence.\n\n\*/}
              {/*            The color palette, characterized by softer hues and minimalistic design elements, further aids in reducing cognitive load, making the trading experience more approachable.\n\n\*/}
              {/*            However, the beauty of this mode lies in its scalability; as users grow more comfortable and seek advanced features, they can effortlessly transition to the platform's full version."}*/}
              {/*          comingSoon*/}
              {/*          color={"#000"}>*/}
              {/*        <div className="flex justify-center ">*/}
              {/*            <Lottie*/}
              {/*                animationData={proLight}*/}
              {/*                style={{width: 100}}*/}
              {/*                loop={true}*/}
              {/*            />*/}
              {/*        </div>*/}
              {/*        <h2 className="sectionh3 dark  md:pb-6">Copy <br/> Trading</h2>*/}
              {/*        <motion.img*/}
              {/*            initial={{opacity: 0, y: 200}}*/}
              {/*            whileInView={{opacity: 1, y: 0}}*/}
              {/*            transition={{delay: 0.2, duration: 0.7}} src='/images/home/lightmode.png'/>*/}
              {/*    </Card>*/}
              {/*    <Card title={"Margin"} text={"We are thrilled to announce the soon-to-be-launched Margin Trading feature on EXZi, designed to elevate your trading experience to new heights. \n\n\*/}
              {/*                By leveraging your capital, this innovative addition will allow you to trade larger volumes and potentially earn higher returns.\n\n\*/}
              {/*                Offering a user-friendly interface coupled with robust risk management tools, our Margin Trading feature aims to provide both novice and experienced traders with a secure, yet dynamic, platform for maximizing their gains.\n\n\*/}
              {/*                Stay tuned for more updates as we gear up for this exciting rollout!"}*/}
              {/*          comingSoon*/}
              {/*          color={"#000"}>*/}
              {/*        <div className="flex justify-center ">*/}
              {/*            <Lottie*/}
              {/*                animationData={leverage}*/}
              {/*                style={{width: 110}}*/}

              {/*                loop={true}*/}
              {/*            />*/}
              {/*        </div>*/}
              {/*        <h2 className="sectionh3 dark  md:pb-6">Margin <br/> Trading</h2>*/}
              {/*        <motion.img*/}
              {/*            initial={{opacity: 0, y: 300}}*/}
              {/*            whileInView={{opacity: 1, y: 0}}*/}
              {/*            transition={{delay: 0.2, duration: 0.7}} src='/images/home/margin.png'/>*/}
              {/*    </Card>*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="sectionend">
            <div className="generalcontainer w-container">
              <div className="sectiontitle end">
                <div className="sectiontitle end page-anim"/>
                {/* <h2 className="sectionh1 headinghero negative">
                  <span className="text-span-3">Trade</span> <br/>
                  Fearlessly
                </h2> */}
                <h2 className="sectionh1">
                  <span className="text-white">{t(`home.section5.0`)} </span><br/> {t(`home.section5.1`)}
                </h2>
              </div>
              <div className="sectioncta">
                <a
                    id="rsvp3"
                    href="#"
                    className="leftcontent end w-inline-block"
                >
                  <div className="contentmidwrapper end">
                    <div className="div-block-76">
                      <h2 className="sectionh2 inside" style={{color: "#797979"}}>
                        {t(`home.referral.title0`)}{" "}
                        <span className="headinghero sectionh2">{t(`home.referral.title1`)}</span>
                      </h2>
                      <p className="disclaimerusbank">
                        {t(`home.referral.text1`)}<br/>
                        <br/>
                        {t(`home.referral.text2`)}
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                      </p>
                    </div>
                    <div className="flex items-center justify-between w-full">
                      <div className="circlearrow">
                        <LazyLoad offset={200}>
                        <img
                            src="/images/home/arrow-go.svg"
                            loading="lazy"
                            alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                            className="image-18"
                        />
                        </LazyLoad>
                       
                      </div>
                      <LazyLoad offset={200}>
                      <img
                          src="/images/home/ref.svg"
                          loading="lazy"
                          alt="Securely Buy & Sell Crypto - Bitcoin, Eth and Altcoins | EXZi"
                          width={150}
                      />
                      </LazyLoad>
                      
                    </div>
                  </div>
                </a>
                <div className="rightcontent p-2 hidden flex-col relative md:flex "
                     style={{background: "white", flexDirection: "column"}}>
                  <div className="contentmidwrapper relative" style={{zIndex: 10000}}>
                    <div className="div-block-76">
                      <h2 className="sectionh2 inside">
                        <span>{t(`home.contact.0`)}</span><br className="hidden md:block"/> {t(`home.contact.1`)}
                      </h2>
                    </div>
                  </div>
              
                  <Widget
                 
                    id="VoIicwB8"
                    className="my-form h-full"
                  />
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{backgroundColor: "#37ABBA",zIndex: 5}}  className="md:hidden px-3 pb-10 home-styles-container  overflow-hidden">
      <div className="rightcontent p-2 flex flex-col relative w-inline-block "
                     style={{background: "white", flexDirection: "column"}}>
                  <div className="contentmidwrapper relative" style={{zIndex: 10000}}>
                    <div className="div-block-76">
                      <h2 className="sectionh2 inside">
                        <span>{t(`home.contact.0`)}</span><br className="hidden md:block"/> {t(`home.contact.1`)}
                      </h2>
                    </div>
                  </div>
                 
                  <Widget
                 
                    id="VoIicwB8"
                    className="my-form h-full"
                  />
         
                </div>
      </div>
      {/* <Faq/> */}
    
     
    </>
  );
}
